import { RootState } from "app/rootReducer";

const getStudentTokenFromState = (getState: () => RootState) => {
  const { token, student } = getState().studentLogin;
  if (!token) throw new Error("Not logged in");
  return { token, student };
};

export { getStudentTokenFromState };
